import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { HelpCircle } from 'lucide-react';

const faqs = [
  {
    question: 'Apa itu Traders Council Asia Indonesia?',
    answer: 'Traders Council Asia Indonesia adalah komunitas edukasi trading di bawah TCA (Traders Council Asia). Kami menyediakan bot AI untuk analisis chart XAUUSD dan edukasi trading berbasis strategi di grup Telegram.',
  },
  {
    question: 'Bagaimana cara bergabung?',
    answer: 'Jawab quiz singkat di halaman ini untuk menemukan gaya trading Anda, lalu langsung gabung ke grup Telegram kami. Gratis dan tanpa syarat.',
  },
  {
    question: 'Apa yang saya dapat setelah masuk Telegram?',
    answer: 'Anda mendapatkan akses ke bot AI yang bisa dijalankan dengan perintah /scalper, /intraday, atau /swing. Bot akan menganalisis chart XAUUSD secara real-time dengan indikator EMA21, VWAP, RSI, dan HTF Supertrend Bias.',
  },
  {
    question: 'Apakah ini auto-trading atau copy trade?',
    answer: 'Bukan. Bot AI memberikan analisis chart dan setup edukasi, bukan eksekusi otomatis. Semua keputusan trading tetap menjadi tanggung jawab pengguna.',
  },
  {
    question: 'Apakah saya harus punya pengalaman trading?',
    answer: 'Tidak harus. Bot dan materi edukasi dirancang untuk pemula maupun trader berpengalaman yang ingin pendekatan lebih terstruktur.',
  },
  {
    question: 'Berapa biayanya?',
    answer: 'Gratis. Akses grup Telegram dan bot AI tidak dipungut biaya.',
  },
  {
    question: 'Apakah ini nasihat keuangan?',
    answer: 'Tidak. Seluruh konten bersifat edukasi. Trading mengandung risiko dan tidak ada jaminan profit. Selalu gunakan dana yang siap rugi dan lakukan keputusan secara mandiri.',
  },
];

const FAQSection = () => {
  return (
    <section
      className="py-24 md:py-32 relative bg-tc-surface/30"
      data-testid="faq-section"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-tc-primary/10 border border-tc-primary/20 mb-6">
            <HelpCircle className="w-4 h-4 text-tc-primary" />
            <span className="text-sm text-tc-primary font-medium">FAQ</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6">
            Pertanyaan yang sering ditanyakan
          </h2>
          <p className="text-xl text-tc-text-secondary">
            Tentang bot AI, strategi, dan grup Telegram
          </p>
        </motion.div>

        {/* FAQ Accordion */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, idx) => (
              <AccordionItem
                key={idx}
                value={`item-${idx}`}
                className="glass-card rounded-xl border-none px-6 data-[state=open]:border-tc-primary/30"
                data-testid={`faq-item-${idx}`}
              >
                <AccordionTrigger className="text-white hover:text-tc-primary text-left font-heading font-medium py-6 hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-tc-text-secondary pb-6 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;
